import React, { useState, useRef, useEffect } from "react";
import "./PrasadDetailsView.scss";
import viewBless from "../../assets/bless-your-self.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ButtonGroup,
  CircularProgress,
  Dialog,
  Grid,
  Stack,
} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TitleTypography from "../../components/typography/TitleTypography";
import ParagraphTypography from "../../components/typography/ParagraphTypography";
import SubtitleTypographyPrimary from "../../components/typography/SubtitleTypographyPrimary";

import { Remove as RemoveIcon } from "@mui/icons-material";
import { AddIcon } from "@chakra-ui/icons";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

import AlertDialog from "../../components/dialog/AlertDialog";
import {
  formatNumberWithK,
  getCityStateFromTemple,
  getImageListFromTemple,
  getMinimumPrice,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import {
  orderType,
  PUJALOADIMG,
} from "../../utils/Constants";
import ServiceInfo from "../../components/ServiceInfoDetailsTop/ServiceInfo";
import SelectPrasadPackageDilog from "../../components/dialog/SelectPrasadPackageDilog";
import MultiLineTooltip from "../../components/tooltips/MultiLineTooltip";
import { prasadSections } from "../../utils/Constants";
import ImageView from "../../components/ImageView/ImageView";
import BannerCarouselWithVideo from "../../components/ServiceInfoDetailsTop/BannerCarouselWithVideo";
import OfferPriceTypography from "../../components/typography/OfferPriceTypography";
import TrustedLogo from "../../components/trustedLogo/TrustedLogo";
import ShowMoreShowLess from "../../components/ShowMoreShowLess/ShowMoreShowLess";
import SubSectionNav from "../../components/subNavigation/SubSectionNav";
import useStickySwitcher from "../../hooks/useStickySwitcher";

function PrasadDetailsView(props: any) {
  const { t, i18n } = useTranslation();
  const {
    templeProfilePic,
    templeDetails,
    templePersonalInfo,
    handleIncrement,
    handleDecrement,
    filteredprasadList,
    navigateToSeeVideoView,
    getAvilableChadhavaDate,
    totalPrice,
    totalPriceDisplay,
    isDateTimePicker,
    shouldDisableDate,
    setPujaDateAndTime,
    pujaDateAndTime,
    isSingleDatePuja,
    cartInfo,
    setPopupItemAlreadyAddedInCart,
    overSeasRate,
    currencySymbols,
    isOverseas,
    preprocessingAndProceedToAddmemberScreen,
    popupItemAlreadyAddedInCart,
    isCountryDisabledForBooking,
    isLoading,
    setItemAddLimitPopUp,
    itemAddLimitPopUp,
    selectedPrasadItem,
    isPrasadPkgOpen,
    setIsPrasadPkgOpen,
    setSelectedPrasadItem,
    handleSelectPrasadPkg,
    isOverLimit,
    setIsOverLimit,
    totalPriceBreakup,
  } = props;

  const [isActiveTemple, setisActiveTemple] = useState<any>(false);
  // const [activeSection, setActiveSection] = useState("");
  // Chadhava Add Popup
  const [isPopupOpen, setPopupOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);

  // CUSTOM HOOKs
  const isAboveFooter = useStickySwitcher(".footerArea", "50px");

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setPopupOpen(false);
    }
  };

  const templeAddress = getCityStateFromTemple(templePersonalInfo);

  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const [urlToShare, setUrlToShare] = useState<string>("");
  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?prasadOftemple=${templeDetails?.nameKey}`
    );
  }, [templeDetails]);

  const [templeName, setTempleName] = useState<string>("");
  const [templeDescriptions, setTempleDescriptions] = useState<string>("");
  const [prasadBenefits, setParsadBenefits] = useState<any>([]);
  let filteredArray = filteredprasadList || [];

  useEffect(() => {
    if (templePersonalInfo?.name) {
      setTempleName(templePersonalInfo?.name);
    }
    const overview = templeDetails?.prasadOverview
      ? templeDetails?.prasadOverview
      : templePersonalInfo?.descriptions;
    setTempleDescriptions(overview || "");
  }, [templePersonalInfo, templeDetails?.prasadOverview]);

  useEffect(() => {
    if (templeDetails?.prasadBenefits) {
      setParsadBenefits(templeDetails?.prasadBenefits);
    }
  }, [templeDetails]);

  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const increment = (item: any) => {
    handleIncrement(item);
  };

  const decrement = (item: any) => {
    handleDecrement(item);
  };

  const addPrasadItem = (item: any) => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
    } else {
      props.addPrasadItem(item);
    }
    // props.addPrasadItem(item);
  };

  // For Temple Details Read More & Less //
  const [isExpandedTempleDetails, setIsExpandedTempleDetails] = useState<any>(
    []
  );

  const toggleReadMore = (id: number) => {
    let tempArr = [...isExpandedTempleDetails];
    if (isExpandedTempleDetails.includes(id)) {
      tempArr = tempArr.filter((item: any) => item !== id);
    } else {
      tempArr.push(id);
    }
    setIsExpandedTempleDetails([...tempArr]);
  };
  const [wordLimit, setWordLimit] = React.useState(
    window.innerWidth < 600 ? 10 : 25
  );

  React.useEffect(() => {
    const handleResize = () => {
      setWordLimit(window.innerWidth < 450 ? 10 : 20);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // END


  const handleCloseAlertDialogForBookingNotAllowed = () => {
    setOpenAlertDialogForBookingNotAllowed(false);
  };

  const handleSetIsDateTimePicker = (isOpen: boolean) => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
    } else {
      // if (cartInfo && cartInfo.length > 0) {
      //   setPopupItemAlreadyAddedInCart(true);
      // } else {
      //   preprocessingAndProceedToAddmemberScreen();
      // }
      preprocessingAndProceedToAddmemberScreen();
    }
  };
  const handleChange1 =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  useEffect(() => {
    let _isActiveTemple = false;
    if (templeDetails) {
      _isActiveTemple =
        templeDetails?.isPrasadEnabled === false ||
        templeDetails?.isClosed === true
          ? false
          : true;
    }
    setisActiveTemple(_isActiveTemple);
  }, [templeDetails]);

  let prasadImages =
    getImageListFromTemple(templePersonalInfo, "prasadPictures") ?? [];

  const formattedPrasadImages = prasadImages.map((item: any) => {
    if (item?.pictureUrl) {
      return { pictureUrl: item.pictureUrl };
    } else if (item?.videoUrl) {
      return { videoUrl: item.videoUrl };
    } else {
      return { pictureUrl: PUJALOADIMG };
    }
  });

  // For Component Purpose
  const bookedCountPrasad = formatNumberWithK(
    filteredArray && filteredArray.length > 0
      ? filteredArray.length * 135
      : 13 * 145
  );

  const prasadBookedText = t(LOCALIZATION.devotees_booked_Prasad);

  const getToolTipInfo = (priceBreakupData: any) => {
    return (
      <>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="listItem"
        >
          <Typography>
            {t("Prasad")} {t(LOCALIZATION.Value)}
          </Typography>
          <Typography className="">
            {`₹${truncateToTwoDecimals(
              priceBreakupData?.finalPrice -
                ((priceBreakupData?.priceBreakup?.delivery || 0) +
                  (priceBreakupData?.priceBreakup?.packaging || 0) +
                  (priceBreakupData?.otherGst || 0))
            )}`}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="listItem"
        >
          <Typography>
            {`${t(LOCALIZATION.Delivary)} + ${t(LOCALIZATION.Packaging)}`}
          </Typography>
          <Typography className="">
            {`₹${truncateToTwoDecimals(
              (priceBreakupData?.priceBreakup?.delivery || 0) +
                (priceBreakupData?.priceBreakup?.packaging || 0) +
                (priceBreakupData?.otherGst || 0)
            )}`}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="listItem"
        >
          <Typography>{t(LOCALIZATION.Total)}</Typography>
          <Typography className="">
            {`₹${truncateToTwoDecimals(priceBreakupData?.finalPrice || 0)}`}
          </Typography>
        </Stack>
      </>
    );
  };

  return (
    <Box className="pageContainer pujaPage">
      <Box className="pujaBlock">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujainfoCenterBlock">
              <Box className="pujaCard" data-scroll-id={"prasad-service-info"}>
                <Grid
                  className="pujaCardBlock"
                  container
                  spacing={{ xs: 0, sm: 0, lg: 2 }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <BannerCarouselWithVideo
                      imageArray={formattedPrasadImages}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <ServiceInfo
                      templeName={templeName}
                      templeAddress={templeAddress}
                      bookedCount={bookedCountPrasad}
                      bookedText={prasadBookedText}
                      itemOrderType={orderType?.prasad}
                      urlToShare={urlToShare}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* <Box className="templeDekhoVideo">
                <SubtitleTypographyPrimary title="About “Temple Dekho”"></SubtitleTypographyPrimary>
                <Typography>
                  Please watch our feature video to discover the capabilities of
                  the <span>Temple Dekho</span> app.
                </Typography>
                <Button
                  onClick={() => navigateToSeeVideoView()}
                  variant="contained"
                  className="seeVideoBtn"
                >
                  See Video
                </Button>
              </Box> */}

              <SubSectionNav sections={prasadSections}/>

              <Box id="prasad-items" data-scroll-id={"prasad-items"}>
                <Box className="chadhavaItemTitle" mb={2}>
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Prasad_Package)}
                  ></SubtitleTypographyPrimary>
                </Box>
                {isLoading === false &&
                  filteredArray?.map((item: any, index: number) => {
                    const finalChadhavaPrice = truncateToTwoDecimals(
                      item.count > 0
                        ? item.priceInfo?.finalPrice || 0
                        : !item.packages || item.packages.length === 0
                        ? Number(item.priceInfo?.finalPrice) || 0
                        : item.selectedPackage
                        ? item.selectedPackage?.priceInfo?.finalPrice || 0
                        : getMinimumPrice(item.packages)
                    );

                    return (
                      <Box
                        className={`chadhavaDetailsBlock chadhavaItems ${
                          item.disabled === true || isActiveTemple === false
                            ? "boxDisable"
                            : ""
                        }`}
                        key={"PrasadItem" + index}
                      >
                        <Box className="chadhavaItem">
                          <Box className="chadhavaLeft">
                            <Box className="mostOfferTag">
                              {item?.isMostOfferedTag && (
                                <span className="offerItem">
                                  {t(LOCALIZATION.Most_Booked)}
                                </span>
                              )}
                            </Box>
                            <Typography sx={{ fontWeight: 500 }}>
                              <span className="itemNameInfo">{item?.name}</span>
                            </Typography>

                            {item?.disabled === true && (
                              <Typography sx={{ color: "red" }}>
                                {getAvilableChadhavaDate()}
                              </Typography>
                            )}

                            <ParagraphTypography
                              title={
                                <ShowMoreShowLess
                                  text={item?.itemDescription || ""}
                                  mode="line"
                                  lines={2}
                                  // limit={300} ->
                                />
                              }
                            />
                            <Box className="priceInfoSection">
                              <Box component="span" className="mainPrice">
                                <TitleTypography
                                  title={`₹${finalChadhavaPrice}${
                                    item.count > 0 ? `× ${item.count}` : ""
                                  }`}
                                />
                              </Box>
                            </Box>
                            {/* <CalculateOverSeasPrice  inrPrice={item?.priceInfo?.finalPrice} priceFor="chadhava"/> */}
                          </Box>
                          <Box className="chadhavaRight">
                            <Box className="itemImg">
                              <ImageView
                                src={item?.image}
                                alt="Item image"
                              ></ImageView>
                            </Box>
                            {item?.count === 0 ? (
                              <Box className="btnAdd">
                                <Button
                                  className="chadhavaAdd"
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    addPrasadItem(item);
                                  }}
                                >
                                  {t(LOCALIZATION.ADD)}
                                </Button>
                              </Box>
                            ) : (
                              <Box className="addItemsBtns">
                                <ButtonGroup className="btnsGroup">
                                  <Button
                                    variant="contained"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      decrement(item);
                                    }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </Button>
                                  <Button variant="contained">
                                    {item?.count}
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={(e) => increment(item)}
                                  >
                                    <AddIcon fontSize="small" />
                                  </Button>
                                </ButtonGroup>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
                {isLoading === true && (
                  <Box className="loadingCircle">
                    <CircularProgress color="primary" />
                  </Box>
                )}
              </Box>
              {/* <Box className="pujaBenefits">
                <SubtitleTypographyPrimary title="Benefits of Prasad"></SubtitleTypographyPrimary>
                {prasadBenefits.map((item: any, id: any) => {
                  return (
                    <Box className="benefitsCard">
                      <SubtitleTypography
                        title={`${item.name}`}
                      ></SubtitleTypography>
                      <Box className="benefitCardImg">
                        <img src={`${item.url}`} alt=""></img>
                      </Box>
                      {item.description && (
                        <ParagraphTypography
                          title={`${item.description}`}
                        ></ParagraphTypography>
                      )}
                    </Box>
                  );
                })}
              </Box> */}
              {templeDescriptions && templeDescriptions.length > 0 && (
                <Box className="overViewText1" id="overview" data-scroll-id={"prasad-Overview"}>
                  <SubtitleTypographyPrimary title={t(LOCALIZATION.Overview)} />
                  <ParagraphTypography
                    title={
                      <ShowMoreShowLess
                        text={templeDescriptions || ""}
                        mode="line"
                        lines={2}
                        // limit={300}
                      />
                    }
                  />
                </Box>
              )}

              <Box className="prasadFaq" id="faq" data-scroll-id={"prasad-Faq"}>
                <SubtitleTypographyPrimary
                  title={t(LOCALIZATION.Frequently_asked_questions)}
                ></SubtitleTypographyPrimary>
                <Box className="chadhavaFaqList">
                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel1"}
                    onChange={handleChange1("panel1")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel1" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel1"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel1-content"
                      id="panel1-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.What_is_the_Prasad_Delivery_Service)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.What_is_the_Prasad_Delivery_ServiceAnswer
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel2"}
                    onChange={handleChange1("panel2")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel2" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel2"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel2-content"
                      id="panel2-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.Which_temples_are_available_for_Prasad_Delivery
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.Which_temples_are_available_for_Prasad_DeliveryAnswer
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel3"}
                    onChange={handleChange1("panel3")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel3" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel3"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel3-content"
                      id="panel3-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(
                        LOCALIZATION.What_items_are_included_the_Prasad_package
                      )}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(
                        LOCALIZATION.What_items_are_included_the_Prasad_packageAnswer
                      )}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel4"}
                    onChange={handleChange1("panel4")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel4" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel4"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel4-content"
                      id="panel4-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.When_will_I_receive_my_Prasad)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(LOCALIZATION.When_will_I_receive_my_PrasadAnswer)}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion
                    className="accordionInfo"
                    expanded={expanded === "panel5"}
                    onChange={handleChange1("panel5")}
                    sx={{
                      "&.Mui-expanded::before": {
                        opacity: 1,
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          sx={{
                            color: expanded === "panel5" ? "#d56939" : "#000",
                            transform:
                              expanded === "panel5"
                                ? "rotate(180deg)"
                                : "rotate(270deg)",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      }
                      aria-controls="panel5-content"
                      id="panel5-header"
                      sx={{
                        p: 0,
                        fontWeight: "600",
                      }}
                    >
                      {t(LOCALIZATION.Is_the_Prasad_authentic)}
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                      {t(LOCALIZATION.Is_the_Prasad_authenticAnswer)}
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Box>

              <TrustedLogo />

              {totalPrice > 0 && isActiveTemple === true && (
                <Box
                  className="chadhavaContinueBtn desktopOnly sticky-button"
                  data-scroll-id={"prasad-continue-button"}
                  sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box className="buttonLeftSec">
                      <MultiLineTooltip
                        tooltipContent={getToolTipInfo(totalPriceBreakup)}
                      />
                      <Typography>
                        {" "}
                        {`₹${
                          totalPriceDisplay ? totalPriceDisplay : totalPrice
                        }`}
                        /-
                      </Typography>
                      {totalPriceBreakup?.offerActualPrice > 0 && (
                        <OfferPriceTypography
                          currencySymbol={currencySymbols ?? "₹"}
                          amount={
                            isOverseas
                              ? truncateToTwoDecimals(
                                  totalPriceBreakup?.offerActualPrice *
                                    overSeasRate
                                )
                              : totalPriceBreakup?.offerActualPrice
                          }
                        />
                      )}
                    </Box>
                    {/* <CalculateOverSeasPrice  inrPrice={Number(props?.totalPrice)} priceFor="chadhava-continue"/> */}

                    <Button
                      className={
                        totalPrice === 0
                          ? "desktopContinueBtnGrey"
                          : "desktopContinueBtn"
                      }
                      onClick={() => handleSetIsDateTimePicker(true)}
                      disabled={totalPrice === 0}
                    >
                      {" "}
                      {t(LOCALIZATION.BOOK_PRASAD)}
                    </Button>
                  </Stack>
                </Box>
              )}
              <Box className="blessContinueChadhava"></Box>
              {totalPrice > 0 && isActiveTemple === true && (
                <Box className="blessContinue">
                  <Box className="viewBless" data-scroll-id={"view-bless"}>
                    <img src={viewBless} alt="view bless"></img>
                  </Box>
                  <Box className="continueCart">
                    <Box className="continueCenterBlock">
                      <Box className="continueLt">
                        <Box className="buttonLeftSec">
                          <MultiLineTooltip
                            tooltipContent={getToolTipInfo(totalPriceBreakup)}
                            isMobileView={true}
                          />
                          <Typography className="priceText">
                            {` ₹${
                              totalPriceDisplay ? totalPriceDisplay : totalPrice
                            }`}
                            /-
                          </Typography>
                          {totalPriceBreakup?.offerActualPrice > 0 && (
                            <OfferPriceTypography
                              currencySymbol={currencySymbols ?? "₹"}
                              amount={
                                isOverseas
                                  ? truncateToTwoDecimals(
                                      totalPriceBreakup?.offerActualPrice *
                                        overSeasRate
                                    )
                                  : totalPriceBreakup?.offerActualPrice
                              }
                            />
                          )}
                        </Box>
                        {/* <CalculateOverSeasPrice  inrPrice={Number(props?.totalPrice)} priceFor="chadhava-continue"/> */}
                      </Box>

                      <Box className="continueRt">
                        <Button
                          type="button"
                          disabled={totalPrice === 0}
                          className={
                            totalPrice === 0 ? "continueBtnDsbl" : "continueBtn"
                          }
                          onClick={() => {
                            if (isSingleDatePuja) {
                              //bookedSingleDatePuja()
                            } else {
                              handleSetIsDateTimePicker(true);
                            }
                          }}
                        >
                          {t(LOCALIZATION.BOOK_PRASAD)}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdRightBlock"
          ></Grid>
        </Grid>
        {/* <Dialog
          className="dateTimingSelection"
          onClose={() => setIsDateTimePicker(false)}
          open={isDateTimePicker}
        >
          <Box className="dateTimePopup">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <TitleTypography title="Select Date">Select Date</TitleTypography>
              <IconButton
                aria-label="close"
                onClick={() => setIsDateTimePicker(false)}
                sx={{
                  position: "absolute",
                  right: 10,
                  top: 6,
                  fontSize: "12px",
                  color: "#d56939",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack> */}

        {/* <Box className="calendarInfo">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  shouldDisableDate={shouldDisableDate}
                  disablePast={true}
                  onChange={(value: any) => {
                    setPujaDateAndTime({
                      ...pujaDateAndTime,
                      pujaDate: value,
                    });
                  }}
                />
              </LocalizationProvider>
            </Box> */}
        {/* <Box className="btnContinue">
              <RoundedButton
                title="Continue"
                // disabled={
                //   pujaDateAndTime && pujaDateAndTime?.pujaDate ? false : true
                // }
                onClick={() => {
                  setIsDateTimePicker(false);
                  if (cartInfo && cartInfo.length > 0) {
                    setPopupItemAlreadyAddedInCart(true);
                  } else {
                    preprocessingAndProceedToAddmemberScreen();
                  }
                  //
                }}
              ></RoundedButton>
            </Box> */}
        {/* </Box>
        </Dialog> */}
        <SelectPrasadPackageDilog
          open={isPrasadPkgOpen}
          selectedPrasad={selectedPrasadItem}
          onClose={() => {
            setIsPrasadPkgOpen(false);
            setSelectedPrasadItem(null);
          }}
          handleSelectPrasadPkg={handleSelectPrasadPkg}
        />
        <Dialog
          // className="dateTimingSelection"
          onClose={() => setPopupItemAlreadyAddedInCart(false)}
          open={popupItemAlreadyAddedInCart}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>
              {t(LOCALIZATION.A_puja_already_added_in_your_cart)}
            </Typography>
            <Box sx={{ textAlign: "end", mt: 1 }}>
              <Button onClick={() => setPopupItemAlreadyAddedInCart(false)}>
                {t(LOCALIZATION.No)}
              </Button>
              <Button
                onClick={() => preprocessingAndProceedToAddmemberScreen()}
              >
                {t(LOCALIZATION.Yes)}
              </Button>
            </Box>
          </Box>
        </Dialog>
        <Dialog
          onClose={() => setItemAddLimitPopUp(false)}
          open={itemAddLimitPopUp}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>{t(LOCALIZATION.Cart_Max_Limit_Message)}</Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setItemAddLimitPopUp(false)}>
                {t(LOCALIZATION.OK)}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      <AlertDialog
        open={openAlertDialogForBookingNotAllowed}
        onClose={handleCloseAlertDialogForBookingNotAllowed}
        message={t(
          LOCALIZATION.Prasad_Bookings_are_not_permitted_in_your_country
        )}
      />
      <AlertDialog
        open={isOverLimit}
        onClose={() => {
          setIsOverLimit(false);
        }}
        message={t(LOCALIZATION.Max_Prasad_Item_Message)}
      />
    </Box>
  );
}

export default PrasadDetailsView;
